// src/components/ui/Button.js

import React from 'react';

// We wrap the entire component definition in React.forwardRef
const Button = React.forwardRef(({
  children,
  onClick,
  variant = 'default',
  className = '',
  ...props
}, ref) => { // <-- ref is now the second argument

  const baseStyle = "px-4 py-2 rounded font-medium focus:outline-none focus:ring-2 focus:ring-offset-2";
  let variantStyle = "";

  switch (variant) {
    case 'primary':
      variantStyle = "bg-primary text-white hover:bg-primary-hover focus:ring-primary";
      break;
    case 'secondary':
      variantStyle = "bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-400";
      break;
    case "none":
      variantStyle = ""
      break;
    default:
      variantStyle = "bg-gray-500 text-white hover:bg-gray-600 focus:ring-gray-500";
      break;
  }

  return (
    <button
      onClick={onClick}
      className={`${baseStyle} ${variantStyle} ${className}`}
      ref={ref} // <-- We pass the ref to the actual <button> element
      {...props}
    >
      {children}
    </button>
  );
});

// This is a best-practice for debugging with React DevTools.
Button.displayName = "Button";

export default Button;